import React from 'react';
import Svg, { Path } from 'react-native-svg';

const StarIconFilled = ({ fill }: { fill?: string }) => {
  return (
    <Svg width="14" height="13" viewBox="0 0 14 13" fill="none">
      <Path
        d="M7.00016 10.5159L11.1202 13.0026L10.0268 8.31594L13.6668 5.1626L8.8735 4.74927L7.00016 0.335938L5.12683 4.74927L0.333496 5.1626L3.96683 8.31594L2.88016 13.0026L7.00016 10.5159Z"
        fill={fill || '#0175FF'}
      />
    </Svg>
  );
};

export default StarIconFilled;
